module.exports = __webpack_public_path__ + "staticcomp/img/share.e369df4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/5/share.jpg
// module id = DXim
// module chunks = 39